// removed by extract-text-webpack-plugin
module.exports = {"modalDialog":"modalDialog__2JA90","hiddenButton":"hiddenButton__rFxMH","maxSize":"maxSize__3s6xm","hidden":"hidden__2oyWT"};


//////////////////
// WEBPACK FOOTER
// ./components/modalDialog/style.scss
// module id = 2Er8
// module chunks = 1